import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from "aurelia-framework";

@autoinject
export class GenericCloneDialog {
    private _clone: (name: string, checked: boolean) => Promise<void>;
    public title: string;
    public checkboxText: string = null;
    public checked: boolean;
    public name: string;
    public nameText: string;

    constructor(private dialogClient: DialogClientService) { }

    activate(model) {
        this.title = model.title;
        this.checkboxText = model.checkboxText;
        this.name = model.name;
        this.nameText = model.nameText;
        this._clone = model.clone;
    }

    clone() {
        return new Promise<void>((resolve, reject) => {
            const checked = this.checkboxText ? this.checked : false;
            this._clone(this.name, checked)
                .then(() => {
                    this.dialogClient.hide();
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }

    cancel() {
        this.dialogClient.hide();
    }
}
